var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28711 14.6816C8.80078 14.6816 10.207 14.2031 11.3691 13.3926L15.6367 17.6699C15.8613 17.8848 16.1543 17.9922 16.4668 17.9922C17.1211 17.9922 17.5898 17.4941 17.5898 16.8496C17.5898 16.5469 17.4922 16.2539 17.2676 16.0293L13.0293 11.7812C13.918 10.5898 14.4453 9.11523 14.4453 7.52344C14.4453 3.58789 11.2227 0.365234 7.28711 0.365234C3.3418 0.365234 0.128906 3.58789 0.128906 7.52344C0.128906 11.459 3.3418 14.6816 7.28711 14.6816ZM7.28711 13.0117C4.26953 13.0117 1.78906 10.5312 1.78906 7.52344C1.78906 4.51562 4.26953 2.03516 7.28711 2.03516C10.2949 2.03516 12.7754 4.51562 12.7754 7.52344C12.7754 10.5312 10.2949 13.0117 7.28711 13.0117Z",
    fill: "#92949D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.84ba78d7.svg";
export { ForwardRef as ReactComponent };